import { reactive, ref } from 'vue';
import type { PasswordStrength } from '../types';
import { passwordRegex } from '../utils/regex';

export function usePasswordVisibility(initialVisibility: boolean = false) {
    const visible = ref<boolean>(initialVisibility);

    function toggle() {
        console.log('toggle');
        visible.value = !visible.value;
    }

    return reactive({
        value: visible,
        toggle,
    });
}

export function usePasswordStrength() {
    const strength = ref<PasswordStrength>();

    function check(value: string) {
        if (passwordRegex.strong.test(value)) {
            strength.value = 'strong';
        } else if (passwordRegex.medium.test(value)) {
            strength.value = 'medium';
        } else if (value?.length) {
            strength.value = 'weak';
        }
    }

    return reactive({
        value: strength,
        check,
    });
}
